var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A6AFB9",
    fillRule: "evenodd",
    d: "M9 .667A8.326 8.326 0 0 0 .667 9 8.326 8.326 0 0 0 9 17.333 8.326 8.326 0 0 0 17.333 9 8.326 8.326 0 0 0 9 .667m4.167 11.325-1.175 1.175L9 10.175l-2.992 2.992-1.175-1.175L7.825 9 4.833 6.008l1.175-1.175L9 7.825l2.992-2.992 1.175 1.175L10.175 9z"
  })));
};
export default SvgCloseIcon;